import { motion } from "framer-motion";
import { useState } from "react";
import auth from "../../helpers/auth";
import validator from "validator";
import { useNavigate, useSearchParams } from "react-router-dom";

//Components
import LoginRegisterHeader from "./login_register_header";
import ModalHeader from "../others/ModalHeader";
import axiosConfig from "../../helpers/axiosConfig"
import serverTimeHelper from "../../helpers/serverTimeHelper";
import { useDispatch } from "react-redux";
import { setOrigServerTime } from "../../helpers/serverTime";

function ModalRegister2FA(props) {
  const { setStep, setShowMainModal, setIsOnline, email, password, isAlpha } = props;
  const dispatch = useDispatch();
  const [queryParameters] = useSearchParams();
  
  const OpenningAnimation = { scale: 1, translateY: "-50%" };
  const ClosingAnimation = { scale: 0, translateY: "-50%" };
  const navigate = useNavigate();
  // eslint-disable-next-line
  const [isOpen, setIsOpen] = useState(true);
  const [verifying, setVerifying] = useState(false);

  const [code, setCode] = useState("");
  const [error, setError] = useState(null);

  function handleChange(e) {
    let val = e.target.value;
    if (!validator.isNumeric(val) && val.length > 0) return;
    if (!validator.isLength(val, { min: 0, max: 6 })) {
      return;
    }
    setCode(val);
    setError(null);
  }

  const toggleOffInContainer = () => {
    if(isAlpha) {
      setStep(null)
    } else {
      setShowMainModal(false);
    }
  };

  function onBack() {
    setStep("register_qr");
  }

  function onSubmit(e) {
    e.preventDefault();

    let hasError = false;
    let errorTracker = error;

    if (
      validator.isEmpty(code) ||
      !validator.isLength(code, { min: 6, max: 6 })
    ) {
      errorTracker = "The provided code is incorrect";
      hasError = true;
    }

    setError(errorTracker);
    if (hasError) return;
    if (verifying) return;
    setVerifying(true);
    const userdata = {
      query: "register",
      email,
      password,
      otp: code,
    };
    let url = process.env.REACT_APP_ENVIRONMENT ==="development" ? `http://${process.env.REACT_APP_HOST}:3003/op/v1/verify`:"https://api.onepeople.online/op/v1/verify";
    axiosConfig
      .post(url, userdata)
      .then((res) => {
        if (res.data.success) {
          auth.setToken(res.data.token);
          auth.setFullName(res.data.user.fullname);
          auth.setId(res.data.user.id);
        
          serverTimeHelper.set(res.data.time)
          dispatch(setOrigServerTime(res.data.time))
          setStep("register_welcome");
          
          let redirect_path = queryParameters.get("redirect");
          if(redirect_path) {
            setTimeout(() => {
              setIsOnline(auth.isOnline());
              window.location.href = redirect_path;
            }, 5000)
          } else {
            setTimeout(() => {
              setIsOnline(auth.isOnline());
              navigate("/");
            }, 5000)
          }
          
        }
      })
      .catch((err) => {
      
        localStorage.clear();
        let errs = err.response.data.errors;
        if (errs) {
          if (errs[0].msg === "connect ETIMEDOUT") {
            errorTracker = "Something went wrong. Please try again.";
          } else {
            errorTracker = "The provided code is incorrect";
          }
        } else {
          errorTracker = "Something went wrong. Please try again.";
        }
        setError(errorTracker);
      })
      .finally(() => {
        setVerifying(false);
      });
  }

  return (
    <motion.div>
      <motion.div
        initial={{ scale: 0.5, translateY: "-50%" }}
        animate={isOpen ? OpenningAnimation : ClosingAnimation}
        transition={{ type: "spring", duration: 0.3 }}
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="op-box p-3 py-5 auth-container OPModalBox position-absolute mx-auto"
      >
        <ModalHeader
          title="Set your authentication app up for 2FA"
          toggleOffInContainer={toggleOffInContainer}
        />
        <div
          className={`row px-3  login-register align-items-center justify-content-center`}
        >
          <div className="register-container col-12 col-md-6 col-lg-6 px-5">
            <form
              autoComplete="off"
              onSubmit={onSubmit}
              className="position-relative"
            >
              <LoginRegisterHeader text="Set up 2FA" uni="&#128221;" />
              <div className="mt-5">
                <p className="auth-text">
                  Enter the 6-digit code displayed by the app to confirm setup
                </p>
              </div>
              <div className="mt-3">
                <div className="m-0 p-0 d-flex justify-content-between">
                  <p className="m-0 p-0 input-text input-error text-gray">
                    2FA code
                  </p>
                  {error && (
                    <p className="m-0 p-0 input-text text-red">{error}</p>
                  )}
                </div>
                <input
                  value={code}
                  onChange={handleChange}
                  type="text"
                  name="code"
                  className="form-control hl-border mt-1"
                  autoComplete="off"
                />
              </div>
              <div className="mt-5 text-center d-flex justify-content-evenly">
                <motion.input
                  initial={{}}
                  animate={
                    verifying
                      ? { backgroundColor: "#ccc", cursor: "not-allowed" }
                      : {}
                  }
                  type="submit"
                  name="submit"
                  value="Confirm"
                  className="op-btn confirm-btn bounce"
                />

                <button onClick={(e) => onBack()} className="btn back-btn">
                  Back
                </button>
              </div>
              <div className="mt-5 text-center"></div>
            </form>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
export default ModalRegister2FA;
